export default {
  title: 'Financeiro',
  default: 'hom',
  shortName: 'FIN',
  menu: [
    {
      id: 'financeiro-home',
      title: 'Principal',
      icon: 'home',
      style: 'regular',
      url: '/#/financeiro'
    },
    {
      id: 'financeiro-contas',
      title: 'Financeiro',
      icon: 'dollar-sign',
      style: 'regular',
      submenu: [
        {
          id: 'financeiro-receitas',
          title: 'A Pagar',
          icon: 'money-check',
          style: 'regular',
          url: '/#/financeiro/contas#pagar'
        },
        {
          id: 'financeiro-despesas',
          title: 'A Receber',
          icon: 'money-check',
          style: 'regular',
          url: '/#/financeiro/contas#receber'
        },
        {
          id: 'financeiro-extrato',
          title: 'Extrato',
          icon: 'receipt',
          style: 'regular',
          url: '/#/financeiro/contas#extrato'
        }
      ]
    },
    {
      id: 'financeiro-compras',
      title: 'Compras',
      icon: 'file-check',
      style: 'regular',
      submenu: [
        {
          id: 'financeiro-compras',
          title: 'Compras',
          disabled: true,
          icon: 'money-check',
          style: 'regular',
          url: '/#/financeiro/compras'
        },
        {
          id: 'financeiro-fornecedores',
          title: 'Fornecedores',
          icon: 'money-check',
          style: 'regular',
          url: '/#/pessoas?paper=fornecedor'
        }
      ]
    },
    {
      id: 'cc',
      title: 'Centro de Custo',
      icon: 'clipboard-list-check',
      style: 'regular',
      url: '/#/financeiro/cc'
    },
    {
      id: 'financeiro-config',
      title: 'Definições',
      icon: 'clipboard-check',
      style: 'regular',
      submenu: [
        {
          id: 'financeiro-categorias',
          title: 'Categorias',
          icon: 'list-tree',
          style: 'regular',
          url: '/#/financeiro/categorias'
        },
        {
          id: 'financeiro-contas',
          title: 'Bancos',
          icon: 'money-bill-trend-up',
          style: 'regular',
          url: '/#/cadastro/bancos'
        }
      ]
    },
    /*{
      id: 'relatorios',
      title: 'Relatórios',
      icon: 'user-chart',
      style: 'regular',
      submenu: [
        {
          id: 'financeiro-receitas',
          title: 'XXX',
          icon: 'money-check',
          style: 'regular',
          submenu: [
            {
              id: 'financeiro-receitas',
              title: 'Contas',
              icon: 'money-check',
              style: 'regular',
              url: '/#/financeiro/contas'
            }
          ]
        },
        {
          id: 'financeiro-despesas',
          title: 'YYY',
          icon: 'money-check',
          style: 'regular',
          url: '/#/financeiro/contas2'
        }
      ]
    }*/
  ]
}
